import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { initialState } from '../initial';

/** Closes the audience members modal - any load still in flight is ignored once requestId is cleared */
export const resetAudienceMembers = (create: ReducerCreators<AudiencesState>) =>
  create.reducer((state) => {
    state.audienceMembers = initialState.audienceMembers;
  });
